import { render, staticRenderFns } from "./UserGroupModal.vue?vue&type=template&id=975e8c42&scoped=true"
import script from "./UserGroupModal.vue?vue&type=script&lang=js"
export * from "./UserGroupModal.vue?vue&type=script&lang=js"
import style0 from "./UserGroupModal.vue?vue&type=style&index=0&id=975e8c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975e8c42",
  null
  
)

export default component.exports